import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { intlDate } from "@faire/web--source/common/localization/date-fns/intlDate";
import { Typography } from "@faire/web--source/slate/Typography";
import { Medium } from "@faire/web--source/ui/Typography/Span";
import { observer } from "mobx-react";
import * as React from "react";
import { usePromoBanners } from "@faire/retailer-visitor-shared/stores/ui/usePromoBanners";
var EmployeeGrantedFreeFreightBannerBase = function() {
    var employeeGrantedFreeFreightDeadline = usePromoBanners().employeeGrantedFreeFreightDeadline;
    var deadline = intlDate(employeeGrantedFreeFreightDeadline !== null && employeeGrantedFreeFreightDeadline !== void 0 ? employeeGrantedFreeFreightDeadline : new Date(), "PPpx");
    return /*#__PURE__*/ _jsxs(Typography, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsx(Medium, {
                children: "You’ve got free shipping"
            }),
            " on your next order! Expires",
            " ",
            /*#__PURE__*/ _jsx(Medium, {
                children: deadline
            })
        ]
    });
};
export var EmployeeGrantedFreeFreightBanner = observer(EmployeeGrantedFreeFreightBannerBase);
